<template>
  <div id="loader">
      <img src="./assets/img/bacteria.png" alt="none" class="loading-icon">
  </div>
  <!-- <nav v-if="!isLogin()">
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
  <router-view/>
</template>

<script>
import APP_DATA from '@/env';

import firebase from 'firebase/compat/app';
import 'firebase/compat/storage';

firebase.initializeApp(APP_DATA.db_config[APP_DATA.env])


export default {
  methods: {
    isLogin(){
      // console.log(this.$route.name)
      return this.$route.name == 'login'
    }
  },
};
</script>

<style>

</style>
